module.exports = __webpack_public_path__ + "img/1521867537.7d8587ea.jpg";